import { REDUX } from 'constants/'
import {
    ILocation,
    LocationAction,
    LocationReducer,
    LocationReducerTypeInitiator,
    LocationSector
} from 'types/location'
/**
 * Reducer para objeto location
 * @param state
 * @param action
 */
const LocationReducers = (
    state = LocationReducerTypeInitiator,
    action: LocationAction
): LocationReducer => {
    switch (action.type) {
        case REDUX.reducers.GET_ALL_LOCATIONS:
            return {
                ...state,
                location: null,
                locationsList: action.payload,
                locationsListNames: action.payload.map(
                    (location: ILocation) =>
                        location['name' as keyof typeof location]
                ),
                error: false,
                loading: false
            } as LocationReducer
        case REDUX.reducers.GET_ALL_LOCATIONS_PAGINATE:
            return {
                ...state,
                locationsListPaginate: action.payload,
                location: null,
                error: false,
                loading: false
            } as LocationReducer
        case REDUX.reducers.GET_LOCATION_BY_ID:
            return {
                ...state,
                location: action.payload[0],
                error: false,
                loading: false
            } as LocationReducer
        case REDUX.reducers.GET_ALL_LOCATIONS_COUNT_LOADING:
            return {
                ...state,
                locationCountLoading: true
            }
        case REDUX.reducers.GET_ALL_LOCATIONS_COUNT:
            return {
                ...state,
                locationCount: action.payload,
                locationCountLoading: false
            }
        case REDUX.reducers.GET_ALL_LOCATIONS_WITH_NOTICATION_COUNT:
            return {
                ...state,
                locationWithNotificationCount: action.payload,
                locationCountLoading: false
            }
        case REDUX.reducers.ERROR_LOCATIONS:
            return {
                ...state,
                error: true,
                loading: false,
                locationCountLoading: false
            } as LocationReducer
        case REDUX.reducers.GET_LOCATIONS_BY_SECTOR_ID:
            return {
                ...state,
                locationSectorList: action.payload,
                locationSectorListDataTable: action.payload.map(
                    (
                        locationSector: LocationSector
                    ): [boolean, string, any] => [
                        false,
                        locationSector.x_rdsls_notificabe_locations
                            .display_value,
                        `${locationSector.u_active.value}|${locationSector.x_rdsls_notificabe_locations.value}`
                    ]
                ),
                error: false,
                loading: false
            } as LocationReducer
        case REDUX.reducers.INIT_UPDATE_LOCATION_SECTOR_LIST:
            return {
                ...state,
                locationSector: action.payload,
                locationSectorList: JSON.parse(
                    JSON.stringify(
                        state.locationSectorList.map((locationSector: any) =>
                            locationSector.x_rdsls_notificabe_locations
                                .value ===
                                action.payload.x_rdsls_notificabe_locations
                                    .value &&
                            locationSector.x_rdsls_notificabe_sectors.value ===
                                action.payload.x_rdsls_notificabe_sectors.value
                                ? action.payload
                                : locationSector
                        )
                    )
                ),
                error: false,
                loading: false
            } as LocationReducer
        case REDUX.reducers.END_UPDATE_LOCATION_SECTOR_LIST:
            return {
                ...state,
                locationSector: action.payload,
                locationSectorList: JSON.parse(
                    JSON.stringify(
                        state.locationSectorList.map((locationSector: any) =>
                            locationSector.x_rdsls_notificabe_locations
                                .value ===
                                action.payload.x_rdsls_notificabe_locations
                                    .value &&
                            locationSector.x_rdsls_notificabe_sectors.value ===
                                action.payload.x_rdsls_notificabe_sectors.value
                                ? action.payload
                                : locationSector
                        )
                    )
                ),
                error: false,
                loading: false
            } as LocationReducer
        case REDUX.reducers.LAST_RETURN_UPDATE_LOCATION_SECTOR:
            return {
                ...state,
                lastReturnUpdateLocationSector: action.payload
            } as LocationReducer
        default:
            return state
    }
}
export default LocationReducers
